export default __webpack_public_path__ + "static/media/tarra-h2h-logotype-d.609a9ec0.svg";